import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=e7fe0ad0&scoped=true&"
import script from "./Platform.vue?vue&type=script&lang=ts&"
export * from "./Platform.vue?vue&type=script&lang=ts&"
import style0 from "./Platform.vue?vue&type=style&index=0&id=e7fe0ad0&prod&lang=scss&"
import style1 from "./Platform.vue?vue&type=style&index=1&id=e7fe0ad0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fe0ad0",
  null
  
)

export default component.exports